exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1FqAS_BlXuOxpz{background:#fff;border-radius:4px;box-shadow:0 1px 3px 0 rgba(9,30,66,.13);width:360px}._2KlpYF95HjnjA_{background:#fff;border-radius:4px;box-sizing:border-box;line-height:1.33;padding:.1px 8px}._1bC5KyI_aSlhGz{align-items:center;display:flex;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;margin:16px 8px}._1lcT8pp_Vi5Z85{display:flex;justify-content:space-between;margin:16px 0 8px}._7U7OTpAs2pgdVT{margin-left:8px;min-width:0;overflow-wrap:break-word;overflow:hidden;word-wrap:break-word}._7U7OTpAs2pgdVT ._2sxXp5zq8ZUBHX{color:#172b4d;font-size:14px;font-weight:700}._7U7OTpAs2pgdVT ._3rLOnr97ahnG2Y{color:#6b778c;font-size:12px}._1dbgtswRRDiwzE{font-size:14px;margin-left:8px}._3yv_J6gLaimejG{color:#000;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-size:14px;margin:16px 8px;overflow-wrap:break-word;word-wrap:break-word}._3DgLhtdRhgaLDd{background:#fff;margin:14px 0 -4px;line-height:2em;display:flex;flex-flow:row wrap}._3sVSFV-Jz_lHyO{background-color:#dfe1e6;border:none;height:1px;margin:20px 0}", ""]);

// exports
exports.locals = {
	"boardAndDetailContainer": "_1FqAS_BlXuOxpz",
	"detailContainer": "_2KlpYF95HjnjA_",
	"header": "_1bC5KyI_aSlhGz",
	"detailActions": "_1lcT8pp_Vi5Z85",
	"detailInfo": "_7U7OTpAs2pgdVT",
	"primary": "_2sxXp5zq8ZUBHX",
	"secondary": "_3rLOnr97ahnG2Y",
	"dueInfo": "_1dbgtswRRDiwzE",
	"commentText": "_3yv_J6gLaimejG",
	"reactionContainer": "_3DgLhtdRhgaLDd",
	"spacer": "_3sVSFV-Jz_lHyO"
};